import Cookies from 'js-cookie';
import { cookiesKey } from '../utils/constants';
import { Navigate, Outlet } from 'react-router-dom';

export default function PublicRoute() {
    const isLoggedIn = Cookies.get(cookiesKey.accessToken);
    return isLoggedIn ? <Navigate to={'/'} /> : <Outlet />
}